// extracted by mini-css-extract-plugin
export default {"bundledProduct":"BundledProductDetails_bundledProduct__jyNqV","price":"BundledProductDetails_price__BB1Ty"};